import type { GraphEdge, GraphFields, GraphSettings } from './types';

export const DEFAULT_FIELDS: Required<GraphFields> = {
	source: 'source',
	target: 'target',
	scope: 'environment',
	calls: 'calls',
	errors: 'errors',
	latency: 'latency_ms',
	traceId: 'trace_id',
	sourceGroup: 'source_group',
	targetGroup: 'target_group',
};

export function edgeTone(
	rate: number | null,
	settings: GraphSettings,
): GraphEdge['tone'] {
	if (rate === null) {
		return 'unknown';
	}
	if (rate > (settings.criticalThreshold ?? 10)) {
		return 'critical';
	}
	if (rate > (settings.warningThreshold ?? 5)) {
		return 'warning';
	}
	return 'normal';
}

export function formatGraphValue(value: number | null, unit = ''): string {
	if (value === null) {
		return '—';
	}
	return `${value.toLocaleString(undefined, { maximumFractionDigits: 2 })}${unit}`;
}
